export enum DocumentStatus {
    UploadedPending = 1,
    NotUploaded = 2,
    NotMandatory = 3, // currently not used and 'Not uploaded' is used in this case
    UploadedNotAccepted = 4,
    UploadedAccepted = 5
}

export const GapClaimDocumentStatusText: Record<DocumentStatus, string> = {
    [DocumentStatus.UploadedPending]: 'Uploaded pending',
    [DocumentStatus.NotUploaded]: 'Not uploaded',
    [DocumentStatus.NotMandatory]: 'Not uploaded',
    [DocumentStatus.UploadedNotAccepted]: 'Uploaded not accepted',
    [DocumentStatus.UploadedAccepted]: 'Uploaded accepted'
};

export const allowUploadStatuses = [
    DocumentStatus.NotUploaded,
    DocumentStatus.NotMandatory,
    DocumentStatus.UploadedNotAccepted
];
